export const BUTTONS_SIZES_KINDS = {
  'xs': 'xs',
  'sm': 'sm',
  'md': 'md',
  'lg': 'lg',
  'xl': 'xl',
  'xxl': 'xxl'
}

export type BUTTONS_SIZES_TYPES = keyof typeof BUTTONS_SIZES_KINDS

export const twScale = [
  0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 62, 72, 80, 96,
]

export const ICONS_SIZES_KINDS = {
  'tiny': '8px',
  'xs': '16px',
  'sm': '20px',
  'md': '24px',
  'lg': '32px',
  'xl': '40px',
}

export type ICONS_SIZES_TYPES = keyof typeof ICONS_SIZES_KINDS

export const ICONS_SIZES_NO_TINY_KINDS = {
  'xs': '16px',
  'sm': '20px',
  'md': '24px',
  'lg': '32px',
  'xl': '40px',
}

export type ICONS_SIZES_NO_TINY_TYPES = keyof typeof ICONS_SIZES_NO_TINY_KINDS
